export default "__VITE_ASSET__ZFxttObs__"